export default [
  // Initial routes
  {
    path: '/',
    redirect: '/external-bi/rebate',
  },
  {
    path: '/home',
    redirect: '/external-bi/rebate',
  },
]
